import { theme } from "settings";

export const getTheme = () => {
  if (process && theme) {
    return theme.toLowerCase();
  } else {
    return "";
  }
};
